<right-panel-action
    [icon]="watched ? 'dku-icon-eye-off-24' : 'dku-icon-eye-24'"
    [tooltip]="watched ? INTEREST_WORDING.tooltips.UNWATCH : INTEREST_WORDING.tooltips.WATCH"
    [disabled]="disabled"
    [disabledTooltip]="disabledTooltip"
    (clicked)="watchedChange.emit(!watched)"
>
    {{watched ? INTEREST_WORDING.labels.UNWATCH : INTEREST_WORDING.labels.WATCH}}
</right-panel-action>